import { render } from "./EditarUser.vue?vue&type=template&id=38c26e56"
import script from "./EditarUser.vue?vue&type=script&lang=js"
export * from "./EditarUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__